export default function SectionHeader({
  eyebrow,
  title,
  desc,
  link,
  linkLabel,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  link?: string;
  linkLabel?: string;
}) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
            <span className="h-px w-6 bg-primary-500" aria-hidden="true" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl leading-snug text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {link && (
        <a
          href={link}
          className="group inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
        </a>
      )}
    </div>
  );
}